import { createUseStyles } from 'react-jss';
export const useSpinnerStyles = createUseStyles((theme) => ({
    spinner: {
        width: ({ size }) => size || '30px',
        height: ({ size }) => size || '30px',
        border: '3px solid rgba(0, 0, 0, 0.1)',
        borderTopColor: ({ color }) => color || theme.colors.primary.main,
        borderRightColor: ({ color }) => color || theme.colors.primary.main,
        borderBottomColor: ({ color }) => color || theme.colors.primary.main,
        borderRadius: '50%',
        animation: '$spin 0.75s linear infinite'
    },
    '@keyframes spin': {
        '0%': {
            transform: 'rotate(0deg)'
        },
        '100%': {
            transform: 'rotate(360deg)'
        }
    }
}));
